export const SET_CONSENTS = 'SET_CONSENTS';